"use client";
import { j as e } from "../node_modules/react/jsx-runtime.js";
import { useContext as s } from "react";
import { PropsContext as o } from "./context.js";
const u = ({ initialState: r, children: t }) => /* @__PURE__ */ e.jsx(o.Provider, { value: r, children: t }), x = () => {
  const r = s(o);
  if (!r)
    throw new Error("usePropsContext must be used within a PropsProvider");
  return r;
};
export {
  u as default,
  x as usePropsContext
};
